module.exports = __webpack_public_path__ + "img/document.6628d0dc.svg";